<template>
  <div role="dialog"
    id="assessment-modal"
    class="assessment-modal popup-modal"
    :class="{ 'is-active': isOpen }"
  >
    <!-- <div class="modal-background"></div> -->
    
    <div class="modal-card">
        <a role="button" tabindex="0" @click="onCancel" @keydown.enter="onCancel" id="closeButton" class="close-white float-right"></a><br>
      <header class="modal-head">
        <h4 class="assessment-modal-title">This will clear all your responses in this tool.</h4>
      </header>
      <section>
        <p>
          All your progress on this tool - including all your comments - will be permanently deleted. <br /><br />
          You may wish to download a PDF summary of your responses and comments before doing this.
        </p>
      </section>
      <footer class="modal-foot d-flex flex-md-row flex-column-reverse">
          <a role="button" tabindex="0" class="cancel" @click="onCancel" @keydown.enter="onCancel">Cancel</a>
          <a role="button" tabindex="0" class="nosave" @click="routeToActionPlan(satId)" @keydown.enter="routeToActionPlan(satId)"
            >View detailed summary<span class="angle-right-white"></span
          ></a>
          <button class="cta-green-219" @click="deleteResponses" @keydown.enter="deleteResponses">
            Delete responses<span class="angle-right-green"></span>
          </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { privateRouter } from "../router";

export default {
  name: "Modal",
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    },
    satId: {
      type: Number,
      default: () => 0
    }
  },
  methods: {
    ...mapActions(["deleteAssessmentResponsesAction"]),
    onCancel() {
      this.$emit("handleCancel");
    },
    routeToActionPlan(satId) {
      privateRouter.push({
        name: "ActionPlan",
        query: {
          satId: satId
        }
      });
    },
    routeToOverview() {
      privateRouter.push({
        name: "SATs"
      });
    },
    async deleteResponses() {      
      await this.deleteAssessmentResponsesAction(this.satId);
      this.routeToOverview();
    },
  }
};
</script>

<style lang="sass" scoped></style>
